import { FaUsers } from "react-icons/fa";
import colors from "core/resources/theme/colors";
import DashboardCard from "ui/components/Cards/DashboardCard";
import { useTotalMoradores } from "core/features/dashboards/hooks/useTotalMoradores";
import { useDashboardPrincipal } from "core/features/dashboards/store";

function CardMoradores() {
  const { query } = useDashboardPrincipal();
  const { data, isFetching } = useTotalMoradores(query);

  return (
    <DashboardCard
      isLoading={isFetching}
      positive={true}
      bg={colors.lightGray}
      label="Moradores registrados"
      valuePercent={null}
      value={data?.total ?? 0}
      icon={<FaUsers fontSize="32px" color={colors.darkGray} />}
    />
  );
}

export default CardMoradores;
